export default __webpack_public_path__ + "static/media/file_left_person.5f3da539.png";